module.exports = __webpack_public_path__ + "static/media/menu-new-homepage.b2a13b88.svg";